import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  myAccount: 'My Profile' as const,
  deleteAccount: 'Close my EFEX account' as const,
  myTeam: 'My team' as const,
  contactUs: 'Contact us' as const,
  logout: 'Logout' as const,
  statements: 'Statements' as const,
  irs: 'Tax ID' as const,
  legalRepresentativeDetails: 'Legal Representative Details' as const,
  companyPosition: 'Position at the Company' as const,
  phone: 'Phone Number' as const,
  managerEmail: 'Manager email (if applicable)' as const,
  defaultCurrency: 'Default Currency' as const,
  companyDetails: 'Company information',
  stakeholdersDetails: 'Stakeholders',
  bankAccountLinked: 'Connected Bank Accounts',
  companyFilesLinked: 'Company documents',
  receivePaymentMessage: 'How would you like to receive payment?',
  receivePayAccount: 'In my bank account',
  receivePayWallet: 'In my EFEX wallet',
  receivedInBank: 'Bank',
  receivedInWallet: 'Wallet',
  memberName: 'Name of the member',
  sendInvite: 'Send invite',
  profileBankName: 'Bank Name',
  profileWebsite: 'Website',
  profilePhoneNumber: 'Phone Number',
  memberExists:
    'The user with email: {{email}}, already exist, please try another email.',
  deleteAccountMessage: 'Are you sure you want to close your EFEX account?',
  deleteAccountSubMessage: 'This action cannot be undone.',
  deleteAccountConfirm: 'Yes, close my account',
  deleteAccountConfirmMessage:
    'We have received your request to close your account.',
  deleteAccountConfirmSubMessage: 'Our team will contact you soon.',
  deleteAccountCancel: 'No, keep my account',
  COL: {
    profileTypeAccount: 'NIT (Tax Identification Number)',
    profileContactAccount: 'Account Number',
  },
  MX: {
    profileTypeAccount: 'RFC (Federal Taxpayer Registry)',
    profileContactAccount: 'Account Clabe',
  },
  USA: {
    profileTypeAccount: 'Tax ID' as const,
    profileContactAccount: 'Routing Number',
  },
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const PROFILE_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    myAccount: 'Mi Perfil',
    deleteAccount: 'Cerrar mi cuenta EFEX',
    myTeam: 'Mi equipo',
    contactUs: 'Contáctanos',
    logout: 'Cerrar sesión',
    statements: 'Estados' as const,
    irs: 'RFC (Registro Federal de Contribuyentes)',
    legalRepresentativeDetails: 'Información de Representate Legal',
    companyPosition: 'Posición en la Empresa',
    phone: 'Número telefónico' as const,
    managerEmail: 'Correo Electrónico del Gerente (si aplica)' as const,
    defaultCurrency: 'Moneda predeterminada' as const,
    companyDetails: 'Informacion de la Empresa',
    stakeholdersDetails: 'Stakeholders',
    bankAccountLinked: 'Cuenta de banco asociada',
    companyFilesLinked: 'Documentos de la Empresa',
    receivePaymentMessage: '¿Como le gustaría recibir el pago?',
    receivePayAccount: 'En mi cuenta de banco',
    receivePayWallet: 'En mi wallet EFEX',
    receivedInBank: 'Banco',
    receivedInWallet: 'Wallet',
    memberName: 'Nombre del miembro',
    sendInvite: 'Enviar invitación',
    profileBankName: 'Nombre de Banco',
    profileWebsite: 'Website',
    profilePhoneNumber: 'Número Celular',
    memberExists:
      'El usuario con correo electrónico: {{email}}, ya existe, intente con otro correo electrónico.',
    deleteAccountMessage: '¿Estás seguro de que quieres cerrar tu cuenta EFEX?',
    deleteAccountSubMessage: 'Esta acción no se puede deshacer.',
    deleteAccountConfirm: 'Sí, cerrar mi cuenta',
    deleteAccountConfirmMessage:
      'Hemos recibido tu solicitud para cerrar tu cuenta.',
    deleteAccountConfirmSubMessage:
      'Nuestro equipo se pondrá en contacto contigo pronto.',
    deleteAccountCancel: 'No, mantener mi cuenta',
    COL: {
      profileTypeAccount: 'NIT (Número de Identificación Tributaria)',
      profileContactAccount: 'Número de cuenta',
    },
    MX: {
      profileTypeAccount: 'RFC (Registro Federal de Contribuyentes)',
      profileContactAccount: 'Cuenta Clabe',
    },
    USA: {
      profileTypeAccount: 'Tax ID',
      profileContactAccount: 'Número Routing',
    },
  },
};

export default PROFILE_LANGUAGE_LABELS;
